import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink, RouterModule } from '@angular/router';

@Component({
  selector: 'app-menu-modal',
  imports: [NgClass, RouterModule, MatIconModule],
  templateUrl: './menu-modal.component.html',
  styleUrl: './menu-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuModalComponent implements OnInit {
  dialogRef = inject(DialogRef);
  datax = inject(DIALOG_DATA);
  menuItems: any[] = [];
  user = null;
  isAuthRoute: boolean = false;
  constructor(public router: Router) {
    // Initialization logic can go here if needed
  }
  ngOnInit() {
    // Filter out invalid menu items and ensure they have required properties
    const rawMenuItems = this.datax.menuItems || [];
    this.menuItems = rawMenuItems.filter(
      (item: any) => item && typeof item === 'object' && item.label
    );

    // Check if the current route is an authentication route
    this.isAuthRoute = this.datax.isAuthRoute || false;
    this.user = this.datax.user || null;

    // add profile and logout items if user is authenticated
  }

  openWorkOfArtModal(action: any): void {
    this.dialogRef.close(action); // Cierra el modal actual si es necesario
  }
  closeModal(): void {
    this.dialogRef.close();
  }

  goto(item: any) {
    // Cierra el modal y navega a la ruta especificada
    this.dialogRef.close(item);
  }
}
